import React from 'react';
import { Link } from 'react-router-dom';
import { GitBranch, Trash2 } from 'lucide-react';

const STATUS_COLORS = {
  completed: '#10B981',
  imported: '#A855F7',
  failed: '#A61E17',
  running: '#F2A900',
  paused: '#F2A900',
  created: '#A0A0A0',
};

export default function FrayList({ frays = [], onRemove }) {
  if (!frays.length) {
    return (
      <div className="text-center py-8 text-[#A0A0A0] font-mono text-xs border border-dashed border-[#2A2A2A] rounded-lg">
        No frays yet. Use the launcher above to start one.
      </div>
    );
  }
  const sorted = [...frays].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at),
  );
  return (
    <ul className="space-y-1" data-testid="fray-list">
      {sorted.map((f) => (
        <li
          key={f.id}
          data-testid={`fray-row-${f.id}`}
          className="flex items-center gap-3 p-3 bg-[#1E1E1E] border border-[#2A2A2A] rounded text-xs font-mono hover:border-[#FF4D00] transition-colors"
        >
          <GitBranch className="w-3 h-3 text-[#A0A0A0] shrink-0" />
          <Link
            to={`/fray/${f.id}/results`}
            className="flex-1 text-[#F5F1E8] hover:text-[#FF4D00] truncate"
          >
            {f.template_name || f.title || f.id.slice(0, 8)}
          </Link>
          <span
            data-testid={`fray-status-${f.id}`}
            className="px-2 py-0.5 rounded text-[10px]"
            style={{
              backgroundColor: `${STATUS_COLORS[f.status] || '#A0A0A0'}33`,
              color: STATUS_COLORS[f.status] || '#A0A0A0',
            }}
          >
            {f.status}
          </span>
          {f.created_at && (
            <span className="text-[#A0A0A0] text-[10px]">
              {new Date(f.created_at).toLocaleDateString()}
            </span>
          )}
          {onRemove && (
            <button
              type="button"
              onClick={() => onRemove(f.id)}
              data-testid={`fray-remove-${f.id}`}
              className="p-1 text-[#A0A0A0] hover:text-[#A61E17] shrink-0"
              title="Remove from project (the fray itself is preserved)"
              aria-label="Remove from project"
            >
              <Trash2 className="w-3 h-3" />
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
